import React, {Suspense, memo, useEffect} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/plp"
import Connect from "./connect"
import {useCheckPageSizeLimit} from "../../hooks/useCheckPageSizeLimit"
import type {TemplateSettingsModel} from "../../models/templates"
import {useSetBreakpoint} from "../../hooks/useSetBreakpoint"
import {IS_BROWSER} from "../../utils/window"

interface PlpProps {
    noResults: boolean
    templating: TemplateSettingsModel
    pageSizeLimit: number
    relaxedQuery: string
    fetchSearchCategoryThumbnailsThunk: () => void
}

export const Plp = memo(
    ({noResults, templating, pageSizeLimit, relaxedQuery, fetchSearchCategoryThumbnailsThunk}: PlpProps) => {
        useSetBreakpoint()
        useCheckPageSizeLimit(pageSizeLimit)
        const isOnClient = IS_BROWSER()
        useEffect(() => {
            if (isOnClient) {
                fetchSearchCategoryThumbnailsThunk()
            }
        }, [fetchSearchCategoryThumbnailsThunk])

        const PLPResultsComponent = useTemplatedComponent(templating, MANIFEST)
        return (
            <Suspense>
                <PLPResultsComponent noResults={noResults} relaxedQuery={relaxedQuery} />
            </Suspense>
        )
    },
)
Plp.displayName = "Plp"

export default Connect(Plp)
